import axios from "axios";

const GetCustomizerImages = async (product) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_SHOPIFY_PROXY_URL}/api/graphql`,
      method: "POST",
      data: {
        query: `{
          files(first: 250, query: "filename:CUSTOMIZER_${product}") {
            edges {
              node {
                preview {
                  image {
                    id
                    src
                    width
                    height
                    url(transform: {maxHeight: 100})
                  }
                }
              }
            }
          }
        }`,
      },
    });
    if (response.data.body.data.files) {
      return response.data.body.data.files.edges.map((e) => e.node.preview.image);
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default GetCustomizerImages;
